<template>
  <section class="container">
    <div class="consumer-defense">
      <div class="consumer-defense__banner">
        <BannerRedirect
          :icon="bannerInfo.icon"
          :bg-icon="bannerInfo.bgIcon"
          :title="bannerInfo.title"
          :description="bannerInfo.description"
          :href-internal="bannerInfo.href"
          :bg-color="bannerInfo.bgColor"
        />
      </div>
      <div class="consumer-defense__content">
        <ConsumerContent />
      </div>
      <transition name="slide-fade">
        <button
          v-if="scrolled"
          type="button"
          class="scroll-top"
          @click="scrollToTop"
        >
          <SvgWrapper
            icon="ArrowUp"
          />
        </button>
      </transition>
    </div>
  </section>
</template>

<script>
import BannerRedirect from '@/components/common/BannerRedirect.vue';
import ConsumerContent from '@/components/consumerDefenseComponents/ConsumerContent.vue';
import SvgWrapper from '@/components/base/svg/SvgWrapper.vue';

export default {
  name: 'ConsumerDefenseCode',

  components: {
    BannerRedirect,
    ConsumerContent,
    SvgWrapper,
  },

  data() {
    return {
      bannerInfo: {
        icon: 'AudioDefesaConsumidor',
        bgIcon: 'BannerRedirectBg',
        title: 'Código de defesa do consumidor em áudio!',
        description: 'Escute o código de defesa do consumidor de onde você estiver.',
        href: 'ConsumerDefenseCodeAudio',
        bgColor: '#f8e7e7'
      },
      scrolled: false,
    };
  },

  metaInfo() {
    return {
      title: 'Código de defesa do consumidor',
    };
  },

  created() {
    window.addEventListener('scroll', () => {
      this.scrolled = window.scrollY > 0;
    });
  },

  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.scroll-top {
  position: fixed;
  bottom: 4rem;
  right: 2%;
  height: 1.25rem;
  width: 1.25rem;
  padding: 1rem;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1000;
  box-shadow: $shadow-02;
  transition: all 0.2s ease-in-out;

  @include screen(tablet-big-up) {
    right: 4%;
    height: 1.5rem;
    width: 1.5rem;
    padding: 1.25;
  }

  &:hover {
    background-color: $gray-20;
  }
}

// Slide-Fade
.slide-fade-enter-active {
  transition: all 0.2s ease-in-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(2rem);
  opacity: 0;
}
</style>